import { FC } from "react";
import { faBullseyeArrow } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Group, Text, Tooltip } from "@mantine/core";

import { EpssProbability, EpssScore } from "@protos/sca/v1/sca";

const EPSS_TOOLTIP_CONTENT = (
  <p>
    EPSS (Exploit Prediction Scoring System) probability represents the
    probability (0-100%) of exploitation in the wild in the next 30 days.
  </p>
);

const EPSS_CATEGORIZATION_TO_TEXT = {
  [EpssProbability.HIGH]: "High",
  [EpssProbability.MEDIUM]: "Medium",
  [EpssProbability.LOW]: "Low",
  [EpssProbability.NONE]: "None",
  [EpssProbability.UNSPECIFIED]: "?",
};

export const EpssLabel: FC<{ epss: EpssScore | null }> = ({ epss }) => {
  const EPSS_MIN_CUTOFF = 0.001; // below this score, scores will be shown as, e.g., "< 0.1%"

  const formatEpss = (epss: EpssScore) => {
    const categoryText = EPSS_CATEGORIZATION_TO_TEXT[epss.categorization];
    const scoreTrimmed = epss.score < EPSS_MIN_CUTOFF;
    if (scoreTrimmed)
      return `<${(EPSS_MIN_CUTOFF * 100).toFixed(1)}% (${categoryText})`;
    return `${(epss.score * 100).toFixed(1)}% (${categoryText})`;
  };

  return epss ? (
    <Tooltip label={EPSS_TOOLTIP_CONTENT} w={300} multiline>
      <Group gap="xs">
        <FontAwesomeIcon icon={faBullseyeArrow} />
        <Text component="span" c="gray.7">
          EPSS: {formatEpss(epss)}
        </Text>
      </Group>
    </Tooltip>
  ) : undefined;
};
